import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

// Global Lenis smooth-scroll provider + scroll-restore on route change.
export default function SmoothScroll({ children }) {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const scrollToTarget = () => {
      const hash = window.location.hash;
      if (hash && document.querySelector(hash)) {
        const el = document.querySelector(hash);
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
        else el.scrollIntoView();
      } else if (window.__lenis) {
        window.__lenis.scrollTo(0, { immediate: true });
      } else {
        window.scrollTo(0, 0);
      }
    };
    const id = setTimeout(scrollToTarget, 120);
    return () => clearTimeout(id);
  }, [location.pathname, location.hash]);

  return children;
}
